import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import {
  CommonDialogFooter,
  CommonDialogHeader,
  CommonDialogTrigger,
} from "@/shared/components/dialog/dialog-common";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Fulfillment } from "@/services/backend/relationships/types/fulfillment";
import { useRelationshipsFulfillmentDeleteMutation } from "@/services/backend/relationships/api/fulfillment_service";

export function DeleteFulfillmentDialog({
  fulfillment,
}: {
  fulfillment: Fulfillment;
}) {
  const [open, setOpen] = useState(false);
  const [deleteFulfillment, { isLoading, error, isSuccess, reset }] =
    useRelationshipsFulfillmentDeleteMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      toast.success(t("Arbeitsschein gelöscht"));
      setOpen(false);
    }
  }, [isSuccess, reset]);

  const doDelete = () => {
    if (isLoading) {
      return;
    }

    deleteFulfillment({ id: fulfillment.id });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <CommonDialogTrigger
        icon={Trash2}
        label=""
        size="sm"
        variant="destructive"
      />
      <DialogContent>
        <CommonDialogHeader
          title={t("Arbeitsschein löschen?")}
          description={t("Löscht den zugewiesenen Arbeitsschein.")}
        />
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
